
        <div id="layout-config" class="layout-config" [ngClass]="{'layout-config-active': app.configDialogActive}" (click)="app.configClick=true">
            <div class="layout-config-content">
				<a href="#" id="layout-config-button" class="layout-config-button" (click)="onConfigButtonClick($event)">
					<i class="pi pi-cog"></i>
				</a>
                <a href="#" class="layout-config-close" (click)="onConfigCloseClick($event)">
                    <i class="pi pi-times"></i>
                </a>
                <p-tabView id="config-form-tabs">
                    <p-tabPanel header="Layout Customization">
						<h1>Wrapper Modes</h1>
						<div class="p-grid">
							<div class="p-col p-col-fixed">
								<a href="#" class="layout-config-option" [ngClass]="{'selected': app.wrapperMode === false}"
								   (click)="app.changeWrapperMode($event, false)">
									<img src="assets/layout/images/configurator/wrapper/Boxed.png" alt="prestige"  style="width:100%"/>
									<i class="pi pi-check" *ngIf="app.wrapperMode === false"></i>
								</a>
							</div>
							<div class="p-col p-col-fixed">
								<a href="#" class="layout-config-option"  [ngClass]="{'selected': app.wrapperMode === true}"
								   (click)="app.changeWrapperMode($event, true)">
									<img src="assets/layout/images/configurator/wrapper/FullWidth.png" alt="prestige"  style="width:100%"/>
									<i class="pi pi-check" *ngIf="app.wrapperMode === true"></i>
								</a>
							</div>
						</div>

						<h1>Menu Modes</h1>
						<div class="p-grid">
							<div class="p-col p-col-fixed">
								<a href="#" class="layout-config-option" [ngClass]="{'selected': app.layoutMode === 'horizontal'}"
								   (click)="app.changeLayoutMode($event,'horizontal')">
									<img src="assets/layout/images/configurator/menu/horizontal.png" alt="prestige"  style="width:100%"/>
									<i class="pi pi-check" *ngIf="app.layoutMode === 'horizontal'"></i>
								</a>
							</div>
							<div class="p-col p-col-fixed">
								<a href="#" class="layout-config-option"  [ngClass]="{'selected': app.layoutMode === 'overlay'}"
								   (click)="app.changeLayoutMode($event,'overlay')">
									<img src="assets/layout/images/configurator/menu/overlay.png" alt="prestige"  style="width:100%"/>
									<i class="pi pi-check" *ngIf="app.layoutMode !== 'horizontal'"></i>
								</a>
							</div>
						</div>

						<h1>Colored Themes</h1>
                        <div class="p-grid">
                            <div class="p-col p-col-fixed colors" *ngFor="let l of layoutThemesColored">
                                <a href="#" class="layout-config-option" [ngClass]="{'selected': app.layout === l.file}" [title]="l.name"
								   [ngStyle]="{'background-image': 'linear-gradient(to right, ' + l.color1 +','+ l.color2+')'} "
								   (click)="app.changeLayoutTheme($event,l.file, l.componentTheme, l.scheme)">
                                    <i class="pi pi-check" *ngIf="l.file === app.layout"></i>
                                </a>
                            </div>
                        </div>

						<h1>Image Themes</h1>
						<div class="p-grid">
							<div class="p-col p-col-fixed colors" *ngFor="let l of layoutThemesImage">
								<a href="#" class="layout-config-option" [ngClass]="{'selected': app.layout === l.file}" [title]="l.name"
								   (click)="app.changeLayoutTheme($event,l.file, l.componentTheme, l.scheme)">
									<img src="assets/layout/images/configurator/layout/{{l.image}}" alt="{{l.name}}"/>
									<i class="pi pi-check" *ngIf="l.file === app.layout"></i>
								</a>
							</div>
						</div>
                    </p-tabPanel>

                    <p-tabPanel header="Component Themes">
                        <div class="p-grid">
                            <div class="p-col p-col-fixed colors" *ngFor="let componentTheme of componentThemes">
                                <a href="#" class="layout-config-option"
                                   [ngClass]="{'selected': componentTheme.file === app.theme && componentTheme.scheme === app.scheme}"
                                   (click)="app.changeComponentTheme($event,componentTheme.file, componentTheme.scheme)">
                                    <img src="assets/layout/images/configurator/theme/{{componentTheme.image}}"
                                         alt="{{componentTheme.name}}"/>
                                    <i class="pi pi-check"
                                       *ngIf="componentTheme.file === app.theme && componentTheme.scheme === app.scheme"></i>
                                </a>
                            </div>
                        </div>
                    </p-tabPanel>
                </p-tabView>
            </div>
        </div>
    